import btnUtilizationToolsUrl from '../assets/design/image/btn_utilization_tools.png';
import btnExchangeMeetingUrl from '../assets/design/image/btn_mail_magazine.png';
import notificationIconUrl from '../assets/design/icon/icon_notis01.svg';
import notificationLibraryIconUrl from '../assets/design/icon/icon_notis02.svg';
import raboLogoUrl from '../assets/design/icon/rabo_logo.jpg';
import abjCropBlackUrl from '../assets/design/icon/ABJ_crop_black.png';
import jasracFooterUrl from '../assets/design/icon/jasrac_footer_img.jpg';
import nexToneFooterUrl from '../assets/design/icon/nex_tone_footer.png';
import aboutAbjUrl from '../assets/design/icon/about_ABJ.jpg';
import scrollTopIconUrl from '../assets/design/icon/icon_triangle03.svg';

/** フッター・ページトップ等で使う静的画像 URL（v-img / img の src="@/..." は解決されないため import 経由で渡す） */
export {
  btnUtilizationToolsUrl,
  btnExchangeMeetingUrl,
  notificationIconUrl,
  notificationLibraryIconUrl,
  raboLogoUrl,
  abjCropBlackUrl,
  jasracFooterUrl,
  nexToneFooterUrl,
  aboutAbjUrl,
  scrollTopIconUrl,
};

function globContext(context: __WebpackModuleApi.RequireContext): Record<string, string> {
  const modules: Record<string, string> = {};
  context.keys().forEach(key => {
    modules[key] = context(key);
  });
  return modules;
}

const backgroundThemeModules = globContext(
  require.context('../assets/design/background_theme/background', false, /\.jpg$/)
);

const profileIconModules = globContext(require.context('../assets/design/icon/profile', false, /\.svg$/));

const logoModules = globContext(
  require.context('../assets/design/image', false, /^\.\/logo_mottosokka02_.*\.svg$/)
);

function findAsset(modules: Record<string, string>, matcher: (path: string) => boolean): string {
  const entry = Object.entries(modules).find(([path]) => matcher(path));
  return entry?.[1] ?? '';
}

export function getBackgroundThemeUrl(themeId: number): string {
  return findAsset(backgroundThemeModules, path => path.endsWith(`/${themeId}.jpg`));
}

export function getProfileIconUrl(iconId: number | string): string {
  return findAsset(profileIconModules, path => path.endsWith(`/icon_profile${iconId}.svg`));
}

export function getEnvLogoUrl(env: string): string {
  return findAsset(logoModules, path => path.endsWith(`/logo_mottosokka02_${env}.svg`));
}
